import { render } from "./PlanIcon.vue?vue&type=template&id=37447a4e&scoped=true"
import script from "./PlanIcon.vue?vue&type=script&lang=js"
export * from "./PlanIcon.vue?vue&type=script&lang=js"

import "./PlanIcon.vue?vue&type=style&index=0&id=37447a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37447a4e"]])

export default __exports__